import React from 'react';
import LoginBg from '../../../assets/images/login-bg.jpg';
import Logo from '../../../assets/images/logo-bhs-fundo-escuro.svg';
import Cadeado from '../../../assets/icons/senha-claro.svg';

import './style.scss';
import { useAuth } from 'context/AuthContext';

function Home({history}) {
  const { login } = useAuth();

  return (
    <div className="login-page">
      <div className="login-art">
        <img src={LoginBg} alt="Otimizamos negócios e reduzimos custos através da tecnologia" />
      </div>

      <div className="login-wrapper">
        <div>
          <img className="login-logo" src={Logo} alt="BHS" />

          <div className="login-titles">
            <h2>Boas Vindas!</h2>
            <h3>Este é o seu Portal do Cliente</h3>
          </div>

          <div className="login-buttons">
            <button className="login-button" onClick={() => login()}>Entrar</button>
            <button className="forget-password-btn" onClick={() => history.push('/esqueci-minha-senha')}>Esqueci minha senha</button>
          </div>

          <p className="login-ambiente-seguro">
            <img src={Cadeado} alt="" />
            Ambiente seguro e protegido
          </p>
        </div>
      </div>
    </div>
  );
}


export default Home
